import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { NbDialogRef, NbDialogService, NbToastrService } from '@nebular/theme';
import { IPageInfo } from 'ngx-virtual-scroller';
import { format } from 'support';
import { DataSource } from 'ng2-smart-table/lib/lib/data-source/data-source';

import {
  Exercise,
  ExerciseData,
} from 'app/@core/interfaces/common/CalorieFriend/exercise';
import { Labelling } from '../../general-text.component';
import { CustomExerciseData } from 'app/@core/interfaces/common/CalorieFriend/custom-exercise';
import { FitnessItem } from 'app/@core/interfaces/common/CalorieFriend/fitnessItem';
import { PatientData } from 'app/@core/interfaces/common/CalorieFriend/patients';
import { CustomExerciseDefComponent } from '../../custom-exercise/CustomExerciseDef/customexercise-def.component';
import { NativeAppService } from 'app/@core/backend/common/services/native-app.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { cloneDeep } from 'lodash';

/**
 * Component for Selection of Meal Items to add into a Meal
 */
@Component({
  selector: 'app-add-fitness-items',
  templateUrl: './add-fitness-items.component.html',
  styleUrls: [
    './add-fitness-items.component.scss',
    '../../global.component.scss',
  ],
})
export class AddFitnessItemsComponent {
  ExerciseSource: DataSource;
  CustomExerciseSource: DataSource;
  PublicCustomExerciseSource: DataSource;

  FriendlyNameLabel = 'Name';
  CaloriesLabel = 'Calories';
  ProteinLabel = 'Protein';
  CarbLabel = 'Carbs';
  FatLabel = 'Fats';
  ImageLabel = 'Image';
  Select = 'Select';
  AcceptLabel = 'Close';
  CancelLabel = 'Cancel';
  OptionsLabel = 'Options';
  ExercisesListCountHTML = '';
  ListCountLabel = $localize`:@@Exercises:Exercises`;

  ListWithoutImageCountLabel = $localize`:@@WithoutImages:Without Images`;
  FilterLabel = 'Filter';
  CurrentFilter = '';
  AppliedFilter = '';
  NewMealItemLabel = 'Add New Item To Workout Plan';
  NewCustomMealItemLabel = 'Add New Item';

  CustomExerciseListCountHTML = '';
  ListFromCustomExerciseCountLabel = $localize`:@@MyExercise:My Exercise`;

  Labels: Labelling;

  SelectedExercise: Array<Exercise>;

  LoadedCurrentlyActiveExercise: Array<Exercise> = null;
  private CurrentlyActiveExercise: Array<Exercise> = new Array<Exercise>();

  Items: Array<any> = new Array<any>();
  CustomItems: Array<any> = new Array<any>();

  filterItems = null;
  filterCustomExerciseItems = null;

  CallerParent: any;

  PatientID: number = -1;
  @Input('PatientName') PatientName: string = '';
  @Input('IsPreferredUnitImperial') IsPreferredUnitImperial: boolean = false;

  @ViewChild('ExerciseTable') Exercises: any = null;
  @ViewChild('SearchField') SearchField: ElementRef;

  allEquipments: Array<any> = [];
  allMuscleTargets: Array<any> = [];
  allBodyParts: Array<any> = [];

  selectedEquipments: Array<any> = [];
  selectedMuscleTargets: Array<any> = [];
  selectedBodyParts: Array<any> = [];
  withVideo: boolean = false;

  constructor(
    private exerciseService: ExerciseData,
    private customExerciseService: CustomExerciseData,
    private dialogService: NbDialogService,
    private toastService: NbToastrService,
    private patientService: PatientData,
    protected ref: NbDialogRef<AddFitnessItemsComponent>,
    private nativeApp: NativeAppService,
    private deviceDetector: DeviceDetectorService,
  ) {
    this.SelectedExercise = new Array<Exercise>();

    this.ExercisesListCountHTML = format('{0} {1}', 0, this.ListCountLabel);
    this.CustomExerciseListCountHTML = format(
      '{0} {1}',
      0,
      this.ListFromCustomExerciseCountLabel
    );

    this.Labels = new Labelling();

    
  }

  /**
   * Initializes the component.
   * Initializes the data source for Exercises and Custom Exercises
   * and their subscriptions.
   */
  ngOnInit(): void {

    //force no keyboard on nativeApp.

    this.ExerciseSource = this.exerciseService.gridDataSource;
    this.CustomExerciseSource =
      this.customExerciseService.gridDataSourceForBlock;

    this.ExerciseSource.onChanged().subscribe((Data) => {
      this.PrepRetrievedItems(Data);

      for (const item of Data.elements) {
        const found = this.Items.find(
          (find) => find.exerciceId == item.exerciceId
        );

        if (found == null || found == undefined) {
          this.Items.push(item);
        }
      }

      this.ExercisesListCountHTML = format(
        '{0} ({1})',
        this.ListCountLabel,
        this.ExerciseSource.count()
      );
    });

    this.CustomExerciseSource.onChanged().subscribe((Data) => {
      this.PrepRetrievedItems(Data);

      for (const item of Data.elements) {
        const found = this.CustomItems.find(
          (find) => find.exerciceId == item.exerciceId
        );

        if (found == null || found == undefined) {
          this.CustomItems.push(item);
        }
      }

      this.CustomExerciseListCountHTML = format(
        '{0} ({1})',
        this.ListFromCustomExerciseCountLabel,
        this.CustomExerciseSource.count()
      );
    });

    // selected exercise
    // filter exercise
    if (this.CurrentlyActiveExercise !== null) {
      for (const exercise of this.CurrentlyActiveExercise) {
        if (exercise !== null && exercise !== undefined)
          this.SelectedExercise.push(exercise);
      }

      this.filterItems = this.CurrentlyActiveExercise.filter(
        (ex) => !ex.isCustom
      ).map((ex) => ex.exerciceId);
      this.RefreshLists();

      this.filterCustomExerciseItems = this.CurrentlyActiveExercise.filter(
        (ex) => ex.isCustom
      ).map((ex) => ex.exerciceId);

      this.RefreshCustomExercisesLists();
    }

    this.exerciseService.GetFilterOptions().subscribe((data) => {
      this.allBodyParts = data.bodyParts;
      this.allEquipments = data.equipments;
      this.allMuscleTargets = data.muscleTargets;


      this.allBodyParts.sort((a, b) => a.name.localeCompare(b.name));
      this.allEquipments.sort((a, b) => a.name.localeCompare(b.name));
      this.allMuscleTargets.sort((a, b) => a.name.localeCompare(b.name));
    });
  }

  isDesktop():boolean  {
    return this.deviceDetector.isDesktop() && !this.nativeApp.isFromApp();
  }

  ngAfterViewInit() {
    this.SearchField.nativeElement.focus();

    if (this.nativeApp.isFromAppFromAndroidApp())
      setTimeout(() => this.nativeApp.sendMessageToApp("PageY", "0"), 25);
  }

  /**
   * Retrieve Item data and updates its presentation including selection UI.
   * @param Data Item data
   */
  private PrepRetrievedItems(Data) {
    if (
      this.CurrentlyActiveExercise != null &&
      this.CurrentlyActiveExercise != undefined
    ) {
      for (const loadExercise of Data.elements) {
        const FoundItem = this.CurrentlyActiveExercise.find(
          (ex) =>
            ex.exerciceId == loadExercise.exerciceId &&
            ex.isCustom == loadExercise.isCustom
        );
        if (FoundItem == null || FoundItem == undefined)
          this.CurrentlyActiveExercise.push(loadExercise);
      }
    } else this.CurrentlyActiveExercise = Data.elements;

    this.PrepareSelectedList();

    for (const exercise of Data.elements) {
      const FoundExercise = this.SelectedExercise.find(
        (x) =>
          x.exerciceId === exercise.exerciceId &&
          x.isCustom === exercise.isCustom
      );
      if (FoundExercise !== null && FoundExercise !== undefined)
        exercise.selected = FoundExercise.selected;
      else exercise.selected = false;
    }
  }

  /**
   * Event handler of 'change' event of Item Selection.
   * Updates the 'Selected' status of the exercise item and add it to the selected exercises list.
   * @param event Event object
   */
  public onItemSelect(event) {
    if (event.data === null) {
      // full selection - de selection
      for (const exercise of this.CurrentlyActiveExercise) {
        exercise.selected = !exercise.selected;
      }
    } else {
      event.data.selected = !event.data.selected;

      if (event.data !== null && event.data !== undefined)
        this.SelectedExercise.push(event.data);
    }
  }

  /**
   * Function to update the selected exercises list.
   */
  private PrepareSelectedList() {
    if (
      this.CurrentlyActiveExercise !== null &&
      this.CurrentlyActiveExercise !== undefined
    ) {
      let Process: Boolean = false;

      for (const ex of this.CurrentlyActiveExercise) {
        Process = false;
        if (ex.selected !== undefined && ex.selected) {
          // see if the item is already in list
          const FoundExercise = this.SelectedExercise.find(
            (curEx) =>
              curEx.exerciceId === ex.exerciceId &&
              curEx.isCustom === ex.isCustom
          );
          if (
            FoundExercise === null ||
            (FoundExercise === undefined && ex !== null && ex !== undefined)
          ) {
            this.SelectedExercise.push(ex);
          }
        }
      }
    }
  }

  /**
   * Event handler of Accept button
   */
  Accept() {
    this.ref.close();
  }

  /**
   * Event handler of Cancel button
   */
  Cancel() {
    this.ref.close();
  }

  /**
   * Add the selected exercise item to the caller's exercise list
   * @param exercise exercise item to add to the list
   */
  PerformItemAdd(exercise) {
    // emit the parent
    if (this.CallerParent && this.CallerParent.UpdateSelectedItem)
      this.CallerParent.UpdateSelectedItem([exercise]);

    // show toast
    this.toastService.success('', `${exercise.name} has been added to plan.`);
  }

  /**
   * Updates the selection and quantity for the Exercise item added
   * @param This Self referencing object
   * @param ItemAdded Item added
   */
  onAddItem(ItemAdded: FitnessItem) {
   
    this.PerformItemAdd(ItemAdded);

    return;

  }

  filteredExercises: string[];
  searchTimeout = null;

  /**
   * Event handler of the auto-complete action.
   * Searches the items within Name or Description fields by the {query} value
   * @param Search Query string to search items
   */
  FilterChange(Search) {
    this.CurrentFilter = Search;

    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }
    this.searchTimeout = setTimeout(
      function (self) {
        self.ApplyFilterChange();
      },
      700,
      this
    );
  }

  /**
   * Function to filter Exercises by query using API service
   * @param query Query
   */
  private filterFunc(query: string): Observable<string[]> {
    return this.exerciseService.GetFilterResult(query);
  }

  /**
   * Activated Search
   */
  ApplyFilterChange() {
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }

    if (this.AppliedFilter != this.CurrentFilter) {
      this.RefreshLists();
      this.RefreshCustomExercisesLists();
    }

    this.AppliedFilter = this.CurrentFilter;
  }

  /**
   * Function to refresh data sources for tables.
   */
  private RefreshLists() {
    if (this.ExerciseSource !== null && this.ExerciseSource !== undefined) {
      this.ExerciseSource.addFilter(
        { field: 'OnlyPictures', search: 'true' },
        true,
        false
      );
      this.ExerciseSource.addFilter(
        { field: 'FriendlyName', search: this.CurrentFilter },
        true,
        false
      );
      this.ExerciseSource.addFilter(
        { field: 'Equipments', search: this.selectedEquipments },
        true,
        false
      );
      this.ExerciseSource.addFilter(
        { field: 'BodyParts', search: this.selectedBodyParts },
        true,
        false
      );
      this.ExerciseSource.addFilter(
        { field: 'MuscleTargets', search: this.selectedMuscleTargets },
        true,
        false
      );
      this.ExerciseSource.addFilter(
        { field: 'WithVideo', search: this.withVideo },
        true,
        false
      );

      this.Items = new Array<any>();
      this.ExerciseSource.setPaging(1, 3, false);

      this.ExerciseSource.refresh();
    }
  }

  /**
   * Function to refresh data source for Custom Exercises list.
   */
  private RefreshCustomExercisesLists() {
    if (
      this.CustomExerciseSource !== null &&
      this.CustomExerciseSource !== undefined
    ) {
      this.CustomExerciseSource.addFilter(
        { field: 'FriendlyName', search: this.CurrentFilter },
        true,
        false
      );

      this.CustomItems = new Array<any>();
      this.CustomExerciseSource.setPaging(1, 3, false);

      this.CustomExerciseSource.refresh();
    }
  }

  /**
   * Event handler of 'New Item' action to add a new custom Exercise.
   * Opens CustomExerciseDefComponent in a pop up dialog.
   */
  onNewCustomFitnessItem() {
    // to-do: Custom Exercise
    this.dialogService
      .open(CustomExerciseDefComponent, {
        closeOnEsc: false,
        context: {
          ID: null,
        },
      })
      .onClose.subscribe((goal) => {
        this.RefreshCustomExercisesLists();
      });
  }

  FetchMoreItem(event: IPageInfo) {
    if (
      this.Items == null ||
      event.endIndex <= 0 ||
      event.endIndex !== this.Items.length - 1
    )
      return;

    this.ExerciseSource.setPaging((event.endIndex + 1) / 3 + 1, 3, true);
  }

  FetchMoreCustomItem(event: IPageInfo) {
    if (
      this.CustomItems == null ||
      event.endIndex <= 0 ||
      event.endIndex !== this.CustomItems.length - 1
    )
      return;

    this.CustomExerciseSource.setPaging(
      Math.round((event.endIndex + 1) / 3) + 1,
      3,
      true
    );
  }

  onSelectedOptionsChange() {
    this.RefreshLists();
  }
}
